import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/lib/cart";
import { Link } from "react-router-dom";
import { Trash2, Plus, Minus } from "lucide-react";

export default function CartDrawer() {
  const { items, open, setOpen, remove, updateQty, totals } = useCart();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="w-full sm:max-w-md bg-cream-50 border-l hairline">
        <SheetHeader>
          <SheetTitle className="font-display text-2xl">Your bag</SheetTitle>
        </SheetHeader>
        {items.length === 0 ? (
          <div className="mt-16 text-center text-ink-500">
            <div className="eyebrow">Empty</div>
            <p className="mt-4 font-display text-2xl text-ink-900">Nothing here yet.</p>
            <Link to="/shop" onClick={() => setOpen(false)} className="mt-6 inline-block btn-gold-outline px-6 py-3 text-xs uppercase tracking-widest">
              Browse products
            </Link>
          </div>
        ) : (
          <div className="mt-6 flex flex-col h-[calc(100vh-8rem)]">
            <div className="flex-1 overflow-auto no-scrollbar space-y-4 pr-1">
              {items.map((it) => (
                <div key={it.key} className="flex gap-4 pb-4 border-b hairline" data-testid={`cart-item-${it.slug}`}>
                  <img src={it.image} alt={it.name} className="w-20 h-24 object-cover bg-cream-200" />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-display text-ink-900 leading-tight">{it.name}</div>
                    {it.subscription && (
                      <div className="eyebrow text-gold-500 mt-1">Subscribe · {it.subscription}</div>
                    )}
                    <div className="mt-2 flex items-center gap-3">
                      <button onClick={() => updateQty(it.key, it.quantity - 1)} className="w-7 h-7 border hairline flex items-center justify-center" aria-label="Decrease">
                        <Minus size={12} />
                      </button>
                      <span className="text-sm tabular-nums w-6 text-center">{it.quantity}</span>
                      <button onClick={() => updateQty(it.key, it.quantity + 1)} className="w-7 h-7 border hairline flex items-center justify-center" aria-label="Increase">
                        <Plus size={12} />
                      </button>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm tabular-nums">₹{(it.price * it.quantity).toFixed(0)}</div>
                    <button onClick={() => remove(it.key)} className="mt-6 text-ink-500 hover:text-ink-900" aria-label="Remove">
                      <Trash2 size={14} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="pt-4 border-t hairline">
              <div className="flex justify-between text-sm">
                <span>Subtotal</span>
                <span className="tabular-nums">₹{totals.subtotal.toFixed(0)}</span>
              </div>
              <div className="text-[11px] text-ink-500 mt-1">Shipping & taxes calculated at checkout.</div>
              <Link
                to="/checkout"
                onClick={() => setOpen(false)}
                className="mt-4 block text-center btn-primary-ink py-4 text-xs uppercase tracking-[0.28em]"
                data-testid="cart-checkout-btn"
              >
                Proceed to checkout →
              </Link>
              <Link
                to="/cart"
                onClick={() => setOpen(false)}
                className="mt-2 block text-center text-xs text-ink-500 hover:text-ink-900 py-2"
              >
                View full bag
              </Link>
            </div>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
